import { fetchCasesListSafe } from './casesListFetch';
import { fetchDraftsListSafe } from './draftsListFetch';
import {
  casesListCacheKey,
  draftsListCacheKey,
  isStale,
  LIST_CACHE_TTL_MS,
} from './listCache';

export async function prefetchCoreLists(workspaceId: string): Promise<void> {
  const draftsKey = draftsListCacheKey(workspaceId);
  const casesKey = casesListCacheKey(workspaceId, false);

  const tasks: Promise<unknown>[] = [];
  if (isStale(draftsKey, LIST_CACHE_TTL_MS)) {
    tasks.push(fetchDraftsListSafe(workspaceId));
  }
  if (isStale(casesKey, LIST_CACHE_TTL_MS)) {
    tasks.push(fetchCasesListSafe(workspaceId, false));
  }

  if (tasks.length === 0) return;
  await Promise.all(tasks);
}

export function schedulePrefetchCoreLists(workspaceId: string): () => void {
  const run = () => {
    void prefetchCoreLists(workspaceId).catch((err) => {
      console.warn('[listPrefetch] prefetch failed', err);
    });
  };

  if (typeof requestIdleCallback !== 'undefined') {
    const id = requestIdleCallback(run, { timeout: 3000 });
    return () => cancelIdleCallback(id);
  }

  const id = window.setTimeout(run, 1500);
  return () => window.clearTimeout(id);
}
